import React from "react";

const LandingPage = ({ t }) => {
  return (
    <div className="cc_landing_container">
      <div className="cc_landing_text_container">
        <h2 className="cc_landing_heading">{t("homepage_title")}</h2>
        <iframe
          src="https://scribehow.com/embed/How_To_Submit_A_New_Delivery_Asset__052FXfAtQEuJgyvb5DVnnQ?as=video"
          title="How to Submit a New Delivery Asset"
          width="100%"
          height="800"
          allowFullScreen
          style={{
            aspectRatio: "16 / 12",
            border: 0,
            minHeight: "480px",
          }}
        />
      </div>
    </div>
  );
};

export default LandingPage;
